import React from "react";
import { Mail } from "lucide-react";
import Reveal from "../common/Reveal";

const ClosingCTA = () => {
  return (
    <section className="bg-primary-950 py-16">
      <Reveal className="mx-auto max-w-2xl px-4 text-center sm:px-6 lg:px-8">
        <h2 className="break-keep text-2xl font-bold leading-relaxed text-white sm:text-3xl">
          도전과 열정을 가진 사람이
          <br />
          MTST의 미래입니다.
        </h2>
        <p className="mt-4 break-keep text-base text-primary-100">
          채용 관련 문의나 지원은 이메일로 이력서와 포트폴리오를 보내주세요.
          담당자가 빠르게 검토 후 연락드리겠습니다.
        </p>
        <div className="mt-8">
          <a
            href="mailto:mtst@mtstech.kr"
            className="inline-flex items-center gap-2 rounded-md bg-white px-6 py-3 text-base font-semibold text-primary-900 transition-all duration-200 hover:-translate-y-0.5 hover:bg-gray-100 hover:shadow-lg"
          >
            <Mail className="h-5 w-5" strokeWidth={2} />
            mtst@mtstech.kr
          </a>
        </div>
      </Reveal>
    </section>
  );
};

export default ClosingCTA;
